import styled from 'styled-components';
import MoneyHeaderSVG from '../../assets/header/ic-money.svg';

const MoneyHeaderIcon = styled(MoneyHeaderSVG as React.SFC<React.SVGProps<SVGSVGElement>>,)`
  width: ${props => props.width || '2.6rem'};
  height: ${props => props.height || '2.4rem'};
  fill: ${props => props.color};
  margin: ${props => props.margin};
`;

export default MoneyHeaderIcon;
